const namespace = 'OFFERS/';

export const SET_OFFERS = `${namespace}SET_OFFERS`;
export const TOGGLE_OFFER = `${namespace}TOGGLE_OFFER`;
export const RESET_OFFERS = `${namespace}RESET_OFFERS`;
